let templateObject = {}

/**
 * Handle Template Animation
 */
const handleTemplateAnimation = () => {
	const $animationContainer = $('.js-template-animations');

	if ($animationContainer.length === 0) {
		return;
	}

	$.ajax({
		url: $animationContainer.data('animation-src'),
		type: 'GET',
		dataType: 'html'
	})
	.done(function(data) {
		$animationContainer.html(data);

		startAnimation();
	});
}

handleTemplateAnimation();

/**
 * Start Animation
 */
const startAnimation = () => {
	const $animationContainer = $('.js-template-animations');
	const $currentStep = $animationContainer.find('.form__step.is-current');
	const animationType = $currentStep.data('animation-type');
	const $cursor = $('.js-template-animations .form__cursor');

	if (animationType === 'field-insert') {
		const $fields = $currentStep.find('input[data-text]');

		if ($fields.length > 0) {
			handleFieldInsert($fields);
		} else {
			nextStep();
		}
	} else if (animationType === 'select-option') {
		const $options = $currentStep.find('input[data-select-option]');

		$cursor.removeClass('hidden');

		if ($options.length > 0) {
			handleSelectOptions($options);
		} else {
			nextStep();
		}
	}
}

/**
 * Listener for form submit
 */
$('.js-template-animations').on('submit', 'form', function(event) {
	const $this = $(this);
	const $form = $this.closest('.form');
	const $formSteps = $this.find('.form__steps');
	const $formResults = $this.find('.form__results');
	const $formCursor = $this.find('.form__cursor');
	const formData = $this.serializeArray();

	$formSteps.hide();

	$formCursor.hide();

	$formResults.show();

	generateTemplateObject(formData);

	updateTemplates();

	$form.addClass('form--submit');

	event.preventDefault();
});

/**
 * Generate Template Object
 * @param  {Object} data
 */
const generateTemplateObject = (data) => {
	const addressData = data.filter(x => x.name === 'field-template-address')[0].value;
	const phoneData = data.filter(x => x.name === 'field-template-phone')[0].value;
	const imageData = data.filter(x => x.name === 'template-image')[0].value;
	const colorPrimaryData = data.filter(x => x.name === 'template-color')[0].value;
	const colorSecondaryData = data.filter(x => x.name === 'template-color')[1].value;
	const logoData = data.filter(x => x.name === 'template-logo')[0].value;

	templateObject = {
		address: addressData,
		phone: phoneData,
		image: imageData,
		colorPrimary: colorPrimaryData,
		colorSecondary: colorSecondaryData,
		logo: logoData
	}
}

/**
 * Update Templates
 */
const updateTemplates = () => {
	const $animationContainer = $('.js-template-animations');
	const $template = $('.template');
	const $templateAdress = $template.find('.template__address');
	const $templatePhone = $template.find('.template__phone');
	const $templateImage = $template.find('.template__image');
	const $templateLogo = $template.find('.template__content img.placeholder');
	const $templateEntry = $template.find('.template__entry');
	const $templateSeparator = $template.find('.template__image-separator');
	let colorsUpdated = false;
	let textUpdated = false;
	let logoUpdated = false;

	$animationContainer.on('template:update', function() {
		if (! textUpdated) {
			updateText($templateAdress, $templatePhone);

			textUpdated = true;
		} else if (! colorsUpdated) {
			updateColors($templateEntry, $templateSeparator);

			colorsUpdated = true;
		} else if (! logoUpdated) {
			updateLogo($templateLogo);

			logoUpdated = true;
		} else {
			setTimeout(function() {
				$('.js-template-animations').off('template:update')
					.off('cursor:reset')
					.off('cursor:update-position');

				templateObject = {};

				handleTemplateAnimation();
			}, 2000);
		}
	});

	updateImage($templateImage);
}

/**
 * Update Image
 * @param  {Object} $images
 */
const updateImage = ($images) => {
	setTimeout(function() {
		$images.css({
			'background-image': `url(${templateObject.image})`,
			'background-size': 'cover'
		});
	
		$images.each(function(index, el) {
			const $video = $(el).find('.template__video');
			
			$video.addClass('is-visible');
		});
		
		$('.js-template-animations').trigger('template:update');

	}, 1000);
}

/**
 * Update Text
 * @param  {Object} $address
 * @param  {Object} $phone
 */
const updateText = ($address, $phone) => {
	setTimeout(function() {
		$address.text(templateObject.address);

		$phone.text(templateObject.phone);

		$('.js-template-animations').trigger('template:update');
	}, 1000);
}

/**
 * Update Colors
 * @param  {Object} $entry
 * @param  {Object} $separator
 */
const updateColors = ($entry, $separator) => {
	setTimeout(function() {
		$entry.css('background-color', templateObject.colorPrimary);

		$separator.css('color', templateObject.colorSecondary);

		$('.js-template-animations').trigger('template:update');
	}, 1000);
}

/**
 * Update Logo
 * @param  {Object} $logo
 */
const updateLogo = ($logo) => {
	setTimeout(function() {
		$logo.addClass('hidden').siblings('img').attr('src', templateObject.logo).removeClass('hidden');

		$('.js-template-animations').trigger('template:update');
	}, 1000);
}

/**
 * Handle Select Options
 * @param  {Object} $options
 */
const handleSelectOptions = ($options) => {
	let optionIndex = 0;
	const optionsArray = [];
	let hoverBtn = false;

	$options.each(function() {
		optionsArray.push($(this))
	});

	let optionPosition = {
		top: optionsArray[optionIndex].parent().position().top + optionsArray[optionIndex].position().top,
		left: optionsArray[optionIndex].parent().position().left + optionsArray[optionIndex].position().left
	}

	$('.js-template-animations').on('cursor:update-position', function() {
		if (! hoverBtn) {
			optionsArray[optionIndex - 1].prop('checked', true);
		}

		if ((optionsArray.length - 1) >= optionIndex) {
			optionPosition.top = optionsArray[optionIndex].parent().position().top + optionsArray[optionIndex].position().top;
			optionPosition.left = optionsArray[optionIndex].parent().position().left + optionsArray[optionIndex].position().left;

			setTimeout(function() {
				updateCursorPosition(optionPosition);
			}, 500);

			optionIndex++;
		} else {
			const $submitBtn = $('.js-template-animations .form__step.is-current .form__btn');

			if ($submitBtn.length > 0) {
				if (! hoverBtn) {
					let btnPosition = {
						top: $submitBtn.position().top + ($submitBtn.height() / 2),
						left: $submitBtn.position().left + ($submitBtn.width() / 2)
					}

					setTimeout(function() {
						updateCursorPosition(btnPosition);
					}, 500);

					hoverBtn = true;
				} else {
					$submitBtn.addClass('is-hover');

					setTimeout(function() {
						$submitBtn.trigger('click');
					}, 500);
				}
			} else {
				setTimeout(function() {
					resetCursor();
				}, 500);
			}
		}
	});

	$('.js-template-animations').on('cursor:reset', function() {
		$('.js-template-animations').off('cursor:update-position')
			.off('cursor:reset');

		setTimeout(function() {
			nextStep();
		}, 1000);
	});

	updateCursorPosition(optionPosition);

	optionIndex++;
}

/**
 * Update Cursor Position
 * @param  {Object} coordinate
 */
const updateCursorPosition = (coordinate) => {
	const $cursor = $('.js-template-animations .form__cursor');

	$cursor.removeClass('hidden');

	$cursor.animate({
		top: coordinate.top,
		left: coordinate.left
	}, 500, function() {
		$cursor.addClass('is-click');

		setTimeout(function() {
			$cursor.removeClass('is-click');

			$('.js-template-animations').trigger('cursor:update-position');
		}, 500);
	});
}

/**
 * Reset Cursor
 */
const resetCursor = () => {
	const $window = $(window);
	const isMobile = $window.innerWidth() <= 767;
	const $cursor = $('.js-template-animations .form__cursor');
	const top = isMobile ? '80%' : '80%';
	const left = isMobile ? '80%' : '85%';

	$cursor.animate({
		top: top,
		left: left
	}, 500, function() {

		$('.js-template-animations').trigger('cursor:reset');
	});
}

/**
 * Handle Field Insert
 * @param  {Object} $fields
 */
const handleFieldInsert = ($fields) => {
	const $animationContainer = $('.js-template-animations');
	let fieldIndex = 0;
	const fieldsArray = [];

	$fields.each(function() {
		fieldsArray.push($(this))
	});

	$('.js-template-animations').on('update', function() {
		if ((fieldsArray.length - 1) >= fieldIndex) {
			insertTextAnimation(fieldsArray[fieldIndex], fieldsArray[fieldIndex].data('text'));

			fieldIndex++;
		} else {
			$animationContainer.off('update');

			setTimeout(function() {
				nextStep();
			}, 1000);
		}
	});

	insertTextAnimation(fieldsArray[fieldIndex], fieldsArray[fieldIndex].data('text'));

	fieldIndex++;
}

/**
 * Insert text animation
 * @param  {[object]} $field
 * @param  {[string]} text
 */
const insertTextAnimation = ($field, text) => {
	const textArray = text.split('');
	let currentPosition = $field.val().length > 0 ? parseInt($field.val().length) : 0;
	const currentText = $field.val();


	if (currentPosition < textArray.length) {
		$field.val(currentText + textArray[currentPosition]);

		currentPosition++;

		setTimeout(function() {
			insertTextAnimation($field, text);
		}, 50);
	} else {
		$('.js-template-animations').trigger('update');
	}
}

/**
 * Change Step or start animation again
 */
const nextStep = () => {
	const $animationContainer = $('.js-template-animations');
	const $currentStep = $animationContainer.find('.form__step.is-current');

	if ($currentStep.next().length > 0) {
		$currentStep.removeClass('is-current')
			.next()
			.addClass('is-current');

		startAnimation();
	}
}
